/**
 * Sidebar Navigation Component
 */
import { Link, useLocation, useNavigate } from "react-router-dom";
import { 
  LayoutDashboard, FileText, Users, Tag, QrCode, Settings, LogOut, Building2, BarChart3, Ticket 
} from "lucide-react";
import { logoutAdmin } from "@/utils/auth";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_instaquote-cleaning/artifacts/wtt4meny_High%20Res%20RS%20Logo%20Teal%201.svg";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/admin/analytics", label: "Analytics", icon: BarChart3 },
    { path: "/admin/franchises", label: "Franchises", icon: Building2 },
    { path: "/admin/quotes", label: "Quotes", icon: FileText },
    { path: "/admin/leads", label: "CRM / Leads", icon: Users },
    { path: "/admin/credits", label: "Credits", icon: Tag },
    { path: "/admin/promo-codes", label: "Promo Codes", icon: Ticket },
    { path: "/admin/campaigns", label: "Campaigns", icon: QrCode },
    { path: "/admin/pricing", label: "Pricing", icon: Settings },
  ];

  const handleLogout = async () => {
    await logoutAdmin();
    navigate("/admin/login");
  };

  return (
    <aside className="admin-sidebar">
      <div className="flex items-center justify-center mb-10">
        <img 
          src={LOGO_URL} 
          alt="Rolling Suds" 
          className="h-20 object-contain"
        />
      </div>

      <nav className="space-y-2">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </Link>
        ))}
      </nav>

      <div className="absolute bottom-6 left-6 right-6">
        <button
          onClick={handleLogout}
          className="admin-nav-item w-full text-red-400 hover:text-red-300 hover:bg-red-900/20"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          Logout
        </button>
      </div>
    </aside>
  );
}
